<template>
    <NavigationMenu />
    <router-view/>
    <Subscribe v-if="isShowSubscribe" />
    <NavigationFoot />
</template>

<script>
    import NavigationMenu from './components/NavigationMenu.vue'
    import NavigationFoot from './components/NavigationFoot.vue'

    export default {
        name: 'App',
        components: {
            NavigationMenu,
            NavigationFoot
        },
        watch: {
            '$route'() {
                //if (to.fullPath.indexOf('/About') != -1 || to.fullPath == '/') {
                //    this.isShowSubscribe = true;
                //} else {
                //    this.isShowSubscribe = false;
                //}
            }
        },
        data() {
            return {
                isShowSubscribe: false
            }
        },
        mounted() {
        }
    }
</script>

<style>
    html, body, #app {
        height: 100%;
        padding: 0;
        margin: 0;
    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        padding-top:84px;
    }

    .custom-image-container{
        overflow:hidden;
    }

    .custom-image {
        transition: transform 0.36s ease;
    }

        .custom-image:hover {
            transform: scale(1.035);
        }

    .custom-title {
        color: rgb(34, 34, 34);
        line-height: 1.5;
        font-family: MiSans-Regular;
        font-size: 20px;
    }

    .custom-content {
        color: rgb(102, 102, 102);
        font-family: MiSans-Light;
        line-height: 1.5;
        font-size: 18px;
    }


        @font-face {
            font-family: 'GreatVibes';
            src: url('./assets/fonts/GreatVibes-Regular.ttf') format('truetype');
            font-weight: normal;
            font-style: normal;
            font-display: swap;
        }

    @font-face {
        font-family: 'MiSans-Light';
        src: url('./assets/fonts/MiSans-Light.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'MiSans-Regular';
        src: url('./assets/fonts/MiSans-Regular.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }


    .big-title {
        font-size: 60px;
        color: black;
        color: rgb(34, 34, 34);
    }

    .big-title-art {
        font-family: GreatVibes;
        font-size: 120px;
    }
    .big-title1 {
        font-size: 60px;
        color: black;
        color: rgb(34, 34, 34);
        text-align: center;
    }

    .big-title-art1 {
        font-family: GreatVibes;
        font-size: 120px;
    }

    .content {
        font-size: 20px;
    }

    .introduce-container1 {
        display: flex;
        padding: 5.20833vw 11.7555% 9.375vw;
    }

    .pd-left-150{
        padding-left:150px;
    }

    .introduce-container3 {
        padding: 10.4167vw 11.8077% 8.33333vw;
        margin: 0vw 0%;
        display: flex;
    }

    .introduce-container3-item {
        flex: 1;
        margin: 10px;
    }

    .subscribe {
        display: flex;
        background-color: rgb(240 240 240);
        height: 50vh;
        min-height: 820px;
        align-items: center;
    }

    .subscribe-item{
        flex:1;
    }

    .subscribe-text {
        margin: 1.00104vw 0 0vw 9.92685%;
    }

    .subscribe-image{
        width:60%;
    }

    .subscribe-email {
        margin: 50px 0;
    }

    .introduce-container2{

    }

    .introduce-container2-item1{
        flex:4;
    }
    .introduce-container2-item2{
        flex:5;
    }

    .mr-top-120 {
        margin-top: 120px;
    }

    .mr-top-40{
        margin-top:40px;
    }
    .mr-top-30{
        margin-top:30px;
    }

    .ma-top-60{
        margin-top:60px;
    }

    .introduce-container2-text {
        margin-top: 100px;
    }

    .introduce-container2-image {
        width: 300px;
    }

    .introduce-container1-item-title {
        margin-top: 5.22466039707419vw;
        margin-right: 0%;
        margin-bottom: 0vw;
        margin-left: 0%;
        padding: 0vw 0% 3.6458333333333335vw 0%;
        color: rgb(34, 34, 34);
        font-family: MiSans-Regular;
    }

    .introduce-container1-item-image {
        width: 45%;
        margin: 10px;
    }

    .foot-container {
        display: flex;
    }

    .foot-item1 {
        width: 25%;
    }

    .foot-item2 {
        width: 33.33%;
    }

    .foot-item3 {
       flex:1;
    }

    .foot-logo{
        width:200px;
    }

    .foot-title{
        font-size: 20px;
    }

    .foot-title-last {
        margin-left: 12px;
    }

    .foot-title-last-image{
        width:80px;
    }

    .mr-100{
        margin:100px;
    }

    @media (max-width: 768px) {
        .big-title, .big-title-art {
            font-size: 24px;
        }
        .big-title1, .big-title-art1 {
            font-size: 30px;
        }

            .content {
                font-size: 16px;
            }

        .foot-container{
            flex-wrap:wrap;
        }

        .foot-item1, .foot-item2, .foot-item23{
            flex:auto;
            width:100%;
        }

        .mr-100{
            margin:10px;
        }

        .foot-logo {
            width: 120px;
        }

        .foot-title{
            font-size:14px;
            margin:0;
            padding:0;
        }
        .foot-title-last-image {
            width: 40px;
        }
        .introduce-container1 {
            padding: 0;
            margin-bottom: 20px;
            flex-wrap: wrap;
        }

        .introduce-container1-item-title {
            margin-left: 30px;
        }

        .introduce-container1-item-image {
            width: 80%;
            margin: 10px auto;
        }

        .pd-left-150 {
            padding-left: 10px;
        }

        .introduce-container3 {
            padding: 10px;
            flex-wrap: wrap;
            margin-bottom: 20px;
        }

        .introduce-container3-item{
            margin:4px;
            flex:auto;
            width:100%;
        }

        .subscribe {
            height: 50vh;
            min-height: 600px;
            flex-wrap: wrap;
        }

        .subscribe-item {
            flex: auto;
            width: 100%;
        }

        .subscribe-text{
            margin:14px;
        }

        .subscribe-image {
            width: 80%;
            margin-right: 40px;
        }

        .subscribe-email {
            margin: 24px 0;
        }

        .introduce-container2 {
            flex-wrap: wrap;
            margin-bottom: 20px;
        }

        .introduce-container1-item{
            flex:auto;
            width:100%;
        }

        .introduce-container2-item1, .introduce-container2-item2 {
            flex: auto;
            width: 100%;
        }

        .mr-top-120, .mr-top-40, .mr-top-30, .ma-top-60 {
            margin-top: 10px;
        }

        .introduce-container2-image{
            width:40vw;
        }

        .introduce-container2-text{
            margin-top:10px;
            align-items:center;
        }
    }

    @media (hover: none), (max-width: 768px) {
        .custom-image:hover {
            transform: none;
        }
    }

    @media (prefers-reduced-motion: reduce) {
        *,
        *::before,
        *::after {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            scroll-behavior: auto !important;
            transition-duration: 0.01ms !important;
        }
    }
</style>
